// extracted by mini-css-extract-plugin
module.exports = {"nav2":"NavBar2_nav2__16SSb","active":"NavBar2_active__Mn8TB","navItems":"NavBar2_navItems__1DHbO","navItemsLink":"NavBar2_navItemsLink__2qSOX"};